import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Cursor for paging through collections */
  ConnectionCursor: any;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONString: object;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  MyDateTime: Date;
};

export enum AutoPredictorMode {
  Disabled = 'Disabled',
  FinishProcessing = 'FinishProcessing',
  ForceVerification = 'ForceVerification',
  PredictAllChildren = 'PredictAllChildren'
}

export type AutoPredictorModeFilterComparison = {
  eq?: InputMaybe<AutoPredictorMode>;
  gt?: InputMaybe<AutoPredictorMode>;
  gte?: InputMaybe<AutoPredictorMode>;
  iLike?: InputMaybe<AutoPredictorMode>;
  in?: InputMaybe<Array<AutoPredictorMode>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<AutoPredictorMode>;
  lt?: InputMaybe<AutoPredictorMode>;
  lte?: InputMaybe<AutoPredictorMode>;
  neq?: InputMaybe<AutoPredictorMode>;
  notILike?: InputMaybe<AutoPredictorMode>;
  notIn?: InputMaybe<Array<AutoPredictorMode>>;
  notLike?: InputMaybe<AutoPredictorMode>;
};

export type BlindProcessingThreshold = {
  __typename?: 'BlindProcessingThreshold';
  confirmedness: Scalars['Float'];
  score: Scalars['Float'];
};

export type BlindProcessingThresholdInput = {
  confirmedness: Scalars['Float'];
  score: Scalars['Float'];
};

export type BooleanFieldComparison = {
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
};

export type CreateDocumentClassSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: DocumentClassSubscriptionFilter;
};

export type CreateLogSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: LogSubscriptionFilter;
};

export type CreateManyDocumentClassesInput = {
  /** Array of records to create */
  documentClasses: Array<DocumentClassCreateDto>;
};

export type CreateManyOrganizationMembershipsInput = {
  /** Array of records to create */
  organizationMemberships: Array<CreateOrganizationMembership>;
};

export type CreateManyOrganizationsInput = {
  /** Array of records to create */
  organizations: Array<CreateOrganization>;
};

export type CreateOneDocumentClassInput = {
  /** The record to create */
  documentClass: DocumentClassCreateDto;
};

export type CreateOneOrganizationInput = {
  /** The record to create */
  organization: CreateOrganization;
};

export type CreateOneUserInput = {
  /** The record to create */
  user: UserCreateInput;
};

export type CreateOrganization = {
  created?: InputMaybe<Scalars['MyDateTime']>;
  /** Stores the menu configuration for different document categories (e.g. classification, extraction, verification, etc...) */
  frontend_category_settings?: InputMaybe<Scalars['JSONString']>;
  identifier?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  show_freshdesk_widget?: InputMaybe<Scalars['Boolean']>;
  updated?: InputMaybe<Scalars['MyDateTime']>;
};

export type CreateOrganizationMembership = {
  created?: InputMaybe<Scalars['MyDateTime']>;
  organization_id?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<OrganizationRole>>;
  updated?: InputMaybe<Scalars['MyDateTime']>;
  user_email?: InputMaybe<Scalars['String']>;
};

export type CreateOrganizationMembershipSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: OrganizationMembershipSubscriptionFilter;
};

export type CreateOrganizationSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: OrganizationSubscriptionFilter;
};

export type CreateRefreshTokenSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: RefreshTokenSubscriptionFilter;
};

export type CreateUserSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: UserSubscriptionFilter;
};

export type CursorPaging = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['ConnectionCursor']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['ConnectionCursor']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']>;
};

export enum DataType {
  None = 'None',
  String = 'String',
  StringMultiline = 'StringMultiline'
}

export type DataTypeFilterComparison = {
  eq?: InputMaybe<DataType>;
  gt?: InputMaybe<DataType>;
  gte?: InputMaybe<DataType>;
  iLike?: InputMaybe<DataType>;
  in?: InputMaybe<Array<DataType>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<DataType>;
  lt?: InputMaybe<DataType>;
  lte?: InputMaybe<DataType>;
  neq?: InputMaybe<DataType>;
  notILike?: InputMaybe<DataType>;
  notIn?: InputMaybe<Array<DataType>>;
  notLike?: InputMaybe<DataType>;
};

export type DateFieldComparison = {
  between?: InputMaybe<DateFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  notBetween?: InputMaybe<DateFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DateFieldComparisonBetween = {
  lower: Scalars['DateTime'];
  upper: Scalars['DateTime'];
};

export type DeleteManyOrganizationMembershipsInput = {
  /** Filter to find records to delete */
  filter: OrganizationMembershipDeleteFilter;
};

export type DeleteManyRefreshTokensInput = {
  /** Filter to find records to delete */
  filter: RefreshTokenDeleteFilter;
};

export type DeleteManyResponse = {
  __typename?: 'DeleteManyResponse';
  /** The number of records deleted. */
  deletedCount: Scalars['Int'];
};

export type DeleteOneDocumentClassSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: DocumentClassSubscriptionFilter;
};

export type DeleteOneLogSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: LogSubscriptionFilter;
};

export type DeleteOneOrganizationMembershipSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: OrganizationMembershipSubscriptionFilter;
};

export type DeleteOneOrganizationSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: OrganizationSubscriptionFilter;
};

export type DeleteOneRefreshTokenInput = {
  /** The id of the record to delete. */
  id: Scalars['String'];
};

export type DeleteOneRefreshTokenSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: RefreshTokenSubscriptionFilter;
};

export type DeleteOneUserSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: UserSubscriptionFilter;
};

export type DocumentClass = {
  __typename?: 'DocumentClass';
  always_include_in_blind_processing_decision: Scalars['Boolean'];
  auto_predictor_mode: AutoPredictorMode;
  blind_processing_thresholds?: Maybe<Array<BlindProcessingThreshold>>;
  category?: Maybe<Scalars['String']>;
  children?: Maybe<DocumentClassChildrenConnection>;
  comments?: Maybe<Scalars['String']>;
  created: Scalars['MyDateTime'];
  deleted_at?: Maybe<Scalars['MyDateTime']>;
  description?: Maybe<Scalars['String']>;
  display_name: Scalars['String'];
  export_enabled?: Maybe<Scalars['Boolean']>;
  export_parallelization?: Maybe<Scalars['Float']>;
  export_queue?: Maybe<Scalars['String']>;
  export_timeout?: Maybe<Scalars['Float']>;
  exporter_settings?: Maybe<Scalars['JSONString']>;
  /** See https://ng-alain.com/form/getting-started/en for more information about the schema definitions. */
  exporter_settings_schema?: Maybe<Scalars['JSONString']>;
  /** unique identifier of this document class. Consists of the local identifiers of all parent classes, separated with a slash. Also needs to begin with a slash. Cannot be directly set. */
  identifier: Scalars['String'];
  identifier_by_organization?: Maybe<Scalars['String']>;
  local_identifier: Scalars['String'];
  /** Should not be set when there is no parent. */
  max_count?: Maybe<Scalars['Int']>;
  /** Should not be set when there is no parent. */
  max_page_count?: Maybe<Scalars['Int']>;
  may_overlap_with_siblings?: Maybe<Scalars['Boolean']>;
  /** Should not be set when there is no parent. */
  min_count?: Maybe<Scalars['Int']>;
  /** Should not be set when there is no parent. */
  min_page_count?: Maybe<Scalars['Int']>;
  /** Sorting parameter */
  order_weight?: Maybe<Scalars['Float']>;
  organization_id: Scalars['ID'];
  parent?: Maybe<DocumentClass>;
  /** Global identifier of this document's parent class */
  parent_id?: Maybe<Scalars['String']>;
  /** info about the possible data that documents of this type may containImportant: In the end we read out what's there; incl. typos and so on.Postprocessing should be applied in the exporter.Therefore, the document's value is always a string (or nothing) */
  possible_value?: Maybe<DataType>;
  prediction_parallelization?: Maybe<Scalars['Float']>;
  prediction_queue?: Maybe<Scalars['String']>;
  prediction_timeout?: Maybe<Scalars['Float']>;
  regex_validators: Array<RegexValidator>;
  search_keywords?: Maybe<Array<Scalars['String']>>;
  /** This field can be used to determine e.g. what kind of UI to show to the user (for the parent document class) If all child classes of a given class have selection mode "Parent", then show a simple classification UI. Similarly: All are "Pages" / "SinglePage" then show page classification. All are "Cutout", then do extraction. Mixed selection modes in the children (or all are "Anything") should probably result in an error message. */
  selection_mode: SelectionMode;
  updated: Scalars['MyDateTime'];
};


export type DocumentClassChildrenArgs = {
  filter?: InputMaybe<DocumentClassFilter>;
  paging?: InputMaybe<CursorPaging>;
  sorting?: InputMaybe<Array<DocumentClassSort>>;
};

export type DocumentClassAggregateGroupBy = {
  __typename?: 'DocumentClassAggregateGroupBy';
  always_include_in_blind_processing_decision?: Maybe<Scalars['Boolean']>;
  auto_predictor_mode?: Maybe<AutoPredictorMode>;
  category?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['MyDateTime']>;
  deleted_at?: Maybe<Scalars['MyDateTime']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  export_enabled?: Maybe<Scalars['Boolean']>;
  export_parallelization?: Maybe<Scalars['Float']>;
  export_queue?: Maybe<Scalars['String']>;
  export_timeout?: Maybe<Scalars['Float']>;
  exporter_settings_schema?: Maybe<Scalars['JSONString']>;
  identifier?: Maybe<Scalars['String']>;
  identifier_by_organization?: Maybe<Scalars['String']>;
  local_identifier?: Maybe<Scalars['String']>;
  may_overlap_with_siblings?: Maybe<Scalars['Boolean']>;
  order_weight?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['ID']>;
  parent_id?: Maybe<Scalars['String']>;
  possible_value?: Maybe<DataType>;
  prediction_parallelization?: Maybe<Scalars['Float']>;
  prediction_queue?: Maybe<Scalars['String']>;
  prediction_timeout?: Maybe<Scalars['Float']>;
  selection_mode?: Maybe<SelectionMode>;
  updated?: Maybe<Scalars['MyDateTime']>;
};

export type DocumentClassAvgAggregate = {
  __typename?: 'DocumentClassAvgAggregate';
  export_parallelization?: Maybe<Scalars['Float']>;
  export_timeout?: Maybe<Scalars['Float']>;
  order_weight?: Maybe<Scalars['Float']>;
  possible_value?: Maybe<Scalars['Float']>;
  prediction_parallelization?: Maybe<Scalars['Float']>;
  prediction_timeout?: Maybe<Scalars['Float']>;
};

export type DocumentClassChildrenConnection = {
  __typename?: 'DocumentClassChildrenConnection';
  /** Array of edges. */
  edges: Array<DocumentClassEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int'];
};

export type DocumentClassConnection = {
  __typename?: 'DocumentClassConnection';
  /** Array of edges. */
  edges: Array<DocumentClassEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type DocumentClassCountAggregate = {
  __typename?: 'DocumentClassCountAggregate';
  always_include_in_blind_processing_decision?: Maybe<Scalars['Int']>;
  auto_predictor_mode?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['Int']>;
  comments?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['Int']>;
  display_name?: Maybe<Scalars['Int']>;
  export_enabled?: Maybe<Scalars['Int']>;
  export_parallelization?: Maybe<Scalars['Int']>;
  export_queue?: Maybe<Scalars['Int']>;
  export_timeout?: Maybe<Scalars['Int']>;
  exporter_settings_schema?: Maybe<Scalars['Int']>;
  identifier?: Maybe<Scalars['Int']>;
  identifier_by_organization?: Maybe<Scalars['Int']>;
  local_identifier?: Maybe<Scalars['Int']>;
  may_overlap_with_siblings?: Maybe<Scalars['Int']>;
  order_weight?: Maybe<Scalars['Int']>;
  organization_id?: Maybe<Scalars['Int']>;
  parent_id?: Maybe<Scalars['Int']>;
  possible_value?: Maybe<Scalars['Int']>;
  prediction_parallelization?: Maybe<Scalars['Int']>;
  prediction_queue?: Maybe<Scalars['Int']>;
  prediction_timeout?: Maybe<Scalars['Int']>;
  selection_mode?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['Int']>;
};

export type DocumentClassCreateDto = {
  always_include_in_blind_processing_decision: Scalars['Boolean'];
  auto_predictor_mode: AutoPredictorMode;
  blind_processing_thresholds?: InputMaybe<Array<BlindProcessingThresholdInput>>;
  category?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  deleted_at?: InputMaybe<Scalars['MyDateTime']>;
  description?: InputMaybe<Scalars['String']>;
  display_name: Scalars['String'];
  export_enabled?: InputMaybe<Scalars['Boolean']>;
  export_parallelization?: InputMaybe<Scalars['Float']>;
  export_queue?: InputMaybe<Scalars['String']>;
  export_timeout?: InputMaybe<Scalars['Float']>;
  exporter_settings?: InputMaybe<Scalars['JSONString']>;
  /** See https://ng-alain.com/form/getting-started/en for more information about the schema definitions. */
  exporter_settings_schema?: InputMaybe<Scalars['JSONString']>;
  identifier_by_organization?: InputMaybe<Scalars['String']>;
  local_identifier: Scalars['String'];
  /** Should not be set when there is no parent. */
  max_count?: InputMaybe<Scalars['Int']>;
  /** Should not be set when there is no parent. */
  max_page_count?: InputMaybe<Scalars['Int']>;
  may_overlap_with_siblings?: InputMaybe<Scalars['Boolean']>;
  /** Should not be set when there is no parent. */
  min_count?: InputMaybe<Scalars['Int']>;
  /** Should not be set when there is no parent. */
  min_page_count?: InputMaybe<Scalars['Int']>;
  /** Sorting parameter */
  order_weight?: InputMaybe<Scalars['Float']>;
  /** Global identifier of this document's parent class */
  parent_id?: InputMaybe<Scalars['String']>;
  /** info about the possible data that documents of this type may containImportant: In the end we read out what's there; incl. typos and so on.Postprocessing should be applied in the exporter.Therefore, the document's value is always a string (or nothing) */
  possible_value?: InputMaybe<DataType>;
  prediction_parallelization?: InputMaybe<Scalars['Float']>;
  prediction_queue?: InputMaybe<Scalars['String']>;
  prediction_timeout?: InputMaybe<Scalars['Float']>;
  regex_validators: Array<RegexValidatorInput>;
  search_keywords?: InputMaybe<Array<Scalars['String']>>;
  /** This field can be used to determine e.g. what kind of UI to show to the user (for the parent document class) If all child classes of a given class have selection mode "Parent", then show a simple classification UI. Similarly: All are "Pages" / "SinglePage" then show page classification. All are "Cutout", then do extraction. Mixed selection modes in the children (or all are "Anything") should probably result in an error message. */
  selection_mode: SelectionMode;
};

export type DocumentClassDeleteResponse = {
  __typename?: 'DocumentClassDeleteResponse';
  always_include_in_blind_processing_decision?: Maybe<Scalars['Boolean']>;
  auto_predictor_mode?: Maybe<AutoPredictorMode>;
  blind_processing_thresholds?: Maybe<Array<BlindProcessingThreshold>>;
  category?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['MyDateTime']>;
  deleted_at?: Maybe<Scalars['MyDateTime']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  export_enabled?: Maybe<Scalars['Boolean']>;
  export_parallelization?: Maybe<Scalars['Float']>;
  export_queue?: Maybe<Scalars['String']>;
  export_timeout?: Maybe<Scalars['Float']>;
  exporter_settings?: Maybe<Scalars['JSONString']>;
  /** See https://ng-alain.com/form/getting-started/en for more information about the schema definitions. */
  exporter_settings_schema?: Maybe<Scalars['JSONString']>;
  /** unique identifier of this document class. Consists of the local identifiers of all parent classes, separated with a slash. Also needs to begin with a slash. Cannot be directly set. */
  identifier?: Maybe<Scalars['String']>;
  identifier_by_organization?: Maybe<Scalars['String']>;
  local_identifier?: Maybe<Scalars['String']>;
  /** Should not be set when there is no parent. */
  max_count?: Maybe<Scalars['Int']>;
  /** Should not be set when there is no parent. */
  max_page_count?: Maybe<Scalars['Int']>;
  may_overlap_with_siblings?: Maybe<Scalars['Boolean']>;
  /** Should not be set when there is no parent. */
  min_count?: Maybe<Scalars['Int']>;
  /** Should not be set when there is no parent. */
  min_page_count?: Maybe<Scalars['Int']>;
  /** Sorting parameter */
  order_weight?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['ID']>;
  /** Global identifier of this document's parent class */
  parent_id?: Maybe<Scalars['String']>;
  /** info about the possible data that documents of this type may containImportant: In the end we read out what's there; incl. typos and so on.Postprocessing should be applied in the exporter.Therefore, the document's value is always a string (or nothing) */
  possible_value?: Maybe<DataType>;
  prediction_parallelization?: Maybe<Scalars['Float']>;
  prediction_queue?: Maybe<Scalars['String']>;
  prediction_timeout?: Maybe<Scalars['Float']>;
  regex_validators?: Maybe<Array<RegexValidator>>;
  search_keywords?: Maybe<Array<Scalars['String']>>;
  /** This field can be used to determine e.g. what kind of UI to show to the user (for the parent document class) If all child classes of a given class have selection mode "Parent", then show a simple classification UI. Similarly: All are "Pages" / "SinglePage" then show page classification. All are "Cutout", then do extraction. Mixed selection modes in the children (or all are "Anything") should probably result in an error message. */
  selection_mode?: Maybe<SelectionMode>;
  updated?: Maybe<Scalars['MyDateTime']>;
};

export type DocumentClassEdge = {
  __typename?: 'DocumentClassEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the DocumentClass */
  node: DocumentClass;
};

export type DocumentClassFilter = {
  always_include_in_blind_processing_decision?: InputMaybe<BooleanFieldComparison>;
  and?: InputMaybe<Array<DocumentClassFilter>>;
  auto_predictor_mode?: InputMaybe<AutoPredictorModeFilterComparison>;
  category?: InputMaybe<StringFieldComparison>;
  comments?: InputMaybe<StringFieldComparison>;
  created?: InputMaybe<DateFieldComparison>;
  deleted_at?: InputMaybe<DateFieldComparison>;
  description?: InputMaybe<StringFieldComparison>;
  display_name?: InputMaybe<StringFieldComparison>;
  export_enabled?: InputMaybe<BooleanFieldComparison>;
  export_parallelization?: InputMaybe<NumberFieldComparison>;
  export_queue?: InputMaybe<StringFieldComparison>;
  export_timeout?: InputMaybe<NumberFieldComparison>;
  exporter_settings_schema?: InputMaybe<ObjectFilterComparison>;
  identifier?: InputMaybe<StringFieldComparison>;
  identifier_by_organization?: InputMaybe<StringFieldComparison>;
  local_identifier?: InputMaybe<StringFieldComparison>;
  may_overlap_with_siblings?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<DocumentClassFilter>>;
  order_weight?: InputMaybe<FloatFieldComparison>;
  organization_id?: InputMaybe<IdFilterComparison>;
  parent_id?: InputMaybe<StringFieldComparison>;
  possible_value?: InputMaybe<DataTypeFilterComparison>;
  prediction_parallelization?: InputMaybe<NumberFieldComparison>;
  prediction_queue?: InputMaybe<StringFieldComparison>;
  prediction_timeout?: InputMaybe<NumberFieldComparison>;
  selection_mode?: InputMaybe<SelectionModeFilterComparison>;
  updated?: InputMaybe<DateFieldComparison>;
};

export type DocumentClassMaxAggregate = {
  __typename?: 'DocumentClassMaxAggregate';
  auto_predictor_mode?: Maybe<AutoPredictorMode>;
  category?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['MyDateTime']>;
  deleted_at?: Maybe<Scalars['MyDateTime']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  export_parallelization?: Maybe<Scalars['Float']>;
  export_queue?: Maybe<Scalars['String']>;
  export_timeout?: Maybe<Scalars['Float']>;
  exporter_settings_schema?: Maybe<Scalars['JSONString']>;
  identifier?: Maybe<Scalars['String']>;
  identifier_by_organization?: Maybe<Scalars['String']>;
  local_identifier?: Maybe<Scalars['String']>;
  order_weight?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['ID']>;
  parent_id?: Maybe<Scalars['String']>;
  possible_value?: Maybe<DataType>;
  prediction_parallelization?: Maybe<Scalars['Float']>;
  prediction_queue?: Maybe<Scalars['String']>;
  prediction_timeout?: Maybe<Scalars['Float']>;
  selection_mode?: Maybe<SelectionMode>;
  updated?: Maybe<Scalars['MyDateTime']>;
};

export type DocumentClassMinAggregate = {
  __typename?: 'DocumentClassMinAggregate';
  auto_predictor_mode?: Maybe<AutoPredictorMode>;
  category?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['MyDateTime']>;
  deleted_at?: Maybe<Scalars['MyDateTime']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  export_parallelization?: Maybe<Scalars['Float']>;
  export_queue?: Maybe<Scalars['String']>;
  export_timeout?: Maybe<Scalars['Float']>;
  exporter_settings_schema?: Maybe<Scalars['JSONString']>;
  identifier?: Maybe<Scalars['String']>;
  identifier_by_organization?: Maybe<Scalars['String']>;
  local_identifier?: Maybe<Scalars['String']>;
  order_weight?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['ID']>;
  parent_id?: Maybe<Scalars['String']>;
  possible_value?: Maybe<DataType>;
  prediction_parallelization?: Maybe<Scalars['Float']>;
  prediction_queue?: Maybe<Scalars['String']>;
  prediction_timeout?: Maybe<Scalars['Float']>;
  selection_mode?: Maybe<SelectionMode>;
  updated?: Maybe<Scalars['MyDateTime']>;
};

export type DocumentClassSort = {
  direction: SortDirection;
  field: DocumentClassSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum DocumentClassSortFields {
  AlwaysIncludeInBlindProcessingDecision = 'always_include_in_blind_processing_decision',
  AutoPredictorMode = 'auto_predictor_mode',
  Category = 'category',
  Comments = 'comments',
  Created = 'created',
  DeletedAt = 'deleted_at',
  Description = 'description',
  DisplayName = 'display_name',
  ExportEnabled = 'export_enabled',
  ExportParallelization = 'export_parallelization',
  ExportQueue = 'export_queue',
  ExportTimeout = 'export_timeout',
  ExporterSettingsSchema = 'exporter_settings_schema',
  Identifier = 'identifier',
  IdentifierByOrganization = 'identifier_by_organization',
  LocalIdentifier = 'local_identifier',
  MayOverlapWithSiblings = 'may_overlap_with_siblings',
  OrderWeight = 'order_weight',
  OrganizationId = 'organization_id',
  ParentId = 'parent_id',
  PossibleValue = 'possible_value',
  PredictionParallelization = 'prediction_parallelization',
  PredictionQueue = 'prediction_queue',
  PredictionTimeout = 'prediction_timeout',
  SelectionMode = 'selection_mode',
  Updated = 'updated'
}

export type DocumentClassSubscriptionFilter = {
  always_include_in_blind_processing_decision?: InputMaybe<BooleanFieldComparison>;
  and?: InputMaybe<Array<DocumentClassSubscriptionFilter>>;
  auto_predictor_mode?: InputMaybe<AutoPredictorModeFilterComparison>;
  category?: InputMaybe<StringFieldComparison>;
  comments?: InputMaybe<StringFieldComparison>;
  created?: InputMaybe<DateFieldComparison>;
  deleted_at?: InputMaybe<DateFieldComparison>;
  description?: InputMaybe<StringFieldComparison>;
  display_name?: InputMaybe<StringFieldComparison>;
  export_enabled?: InputMaybe<BooleanFieldComparison>;
  export_parallelization?: InputMaybe<NumberFieldComparison>;
  export_queue?: InputMaybe<StringFieldComparison>;
  export_timeout?: InputMaybe<NumberFieldComparison>;
  exporter_settings_schema?: InputMaybe<ObjectFilterComparison>;
  identifier?: InputMaybe<StringFieldComparison>;
  identifier_by_organization?: InputMaybe<StringFieldComparison>;
  local_identifier?: InputMaybe<StringFieldComparison>;
  may_overlap_with_siblings?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<DocumentClassSubscriptionFilter>>;
  order_weight?: InputMaybe<FloatFieldComparison>;
  organization_id?: InputMaybe<IdFilterComparison>;
  parent_id?: InputMaybe<StringFieldComparison>;
  possible_value?: InputMaybe<DataTypeFilterComparison>;
  prediction_parallelization?: InputMaybe<NumberFieldComparison>;
  prediction_queue?: InputMaybe<StringFieldComparison>;
  prediction_timeout?: InputMaybe<NumberFieldComparison>;
  selection_mode?: InputMaybe<SelectionModeFilterComparison>;
  updated?: InputMaybe<DateFieldComparison>;
};

export type DocumentClassSumAggregate = {
  __typename?: 'DocumentClassSumAggregate';
  export_parallelization?: Maybe<Scalars['Float']>;
  export_timeout?: Maybe<Scalars['Float']>;
  order_weight?: Maybe<Scalars['Float']>;
  possible_value?: Maybe<Scalars['Float']>;
  prediction_parallelization?: Maybe<Scalars['Float']>;
  prediction_timeout?: Maybe<Scalars['Float']>;
};

export type DocumentClassUpdateDto = {
  always_include_in_blind_processing_decision?: InputMaybe<Scalars['Boolean']>;
  auto_predictor_mode?: InputMaybe<AutoPredictorMode>;
  blind_processing_thresholds?: InputMaybe<Array<BlindProcessingThresholdInput>>;
  category?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  deleted_at?: InputMaybe<Scalars['MyDateTime']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  export_enabled?: InputMaybe<Scalars['Boolean']>;
  export_parallelization?: InputMaybe<Scalars['Float']>;
  export_queue?: InputMaybe<Scalars['String']>;
  export_timeout?: InputMaybe<Scalars['Float']>;
  exporter_settings?: InputMaybe<Scalars['JSONString']>;
  /** See https://ng-alain.com/form/getting-started/en for more information about the schema definitions. */
  exporter_settings_schema?: InputMaybe<Scalars['JSONString']>;
  identifier_by_organization?: InputMaybe<Scalars['String']>;
  /** Should not be set when there is no parent. */
  max_count?: InputMaybe<Scalars['Int']>;
  /** Should not be set when there is no parent. */
  max_page_count?: InputMaybe<Scalars['Int']>;
  may_overlap_with_siblings?: InputMaybe<Scalars['Boolean']>;
  /** Should not be set when there is no parent. */
  min_count?: InputMaybe<Scalars['Int']>;
  /** Should not be set when there is no parent. */
  min_page_count?: InputMaybe<Scalars['Int']>;
  /** Sorting parameter */
  order_weight?: InputMaybe<Scalars['Float']>;
  /** info about the possible data that documents of this type may containImportant: In the end we read out what's there; incl. typos and so on.Postprocessing should be applied in the exporter.Therefore, the document's value is always a string (or nothing) */
  possible_value?: InputMaybe<DataType>;
  prediction_parallelization?: InputMaybe<Scalars['Float']>;
  prediction_queue?: InputMaybe<Scalars['String']>;
  prediction_timeout?: InputMaybe<Scalars['Float']>;
  regex_validators?: InputMaybe<Array<RegexValidatorInput>>;
  search_keywords?: InputMaybe<Array<Scalars['String']>>;
  /** This field can be used to determine e.g. what kind of UI to show to the user (for the parent document class) If all child classes of a given class have selection mode "Parent", then show a simple classification UI. Similarly: All are "Pages" / "SinglePage" then show page classification. All are "Cutout", then do extraction. Mixed selection modes in the children (or all are "Anything") should probably result in an error message. */
  selection_mode?: InputMaybe<SelectionMode>;
};

export type DocumentClassUpdateFilter = {
  always_include_in_blind_processing_decision?: InputMaybe<BooleanFieldComparison>;
  and?: InputMaybe<Array<DocumentClassUpdateFilter>>;
  auto_predictor_mode?: InputMaybe<AutoPredictorModeFilterComparison>;
  category?: InputMaybe<StringFieldComparison>;
  comments?: InputMaybe<StringFieldComparison>;
  created?: InputMaybe<DateFieldComparison>;
  deleted_at?: InputMaybe<DateFieldComparison>;
  description?: InputMaybe<StringFieldComparison>;
  display_name?: InputMaybe<StringFieldComparison>;
  export_enabled?: InputMaybe<BooleanFieldComparison>;
  export_parallelization?: InputMaybe<NumberFieldComparison>;
  export_queue?: InputMaybe<StringFieldComparison>;
  export_timeout?: InputMaybe<NumberFieldComparison>;
  exporter_settings_schema?: InputMaybe<ObjectFilterComparison>;
  identifier?: InputMaybe<StringFieldComparison>;
  identifier_by_organization?: InputMaybe<StringFieldComparison>;
  local_identifier?: InputMaybe<StringFieldComparison>;
  may_overlap_with_siblings?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<DocumentClassUpdateFilter>>;
  order_weight?: InputMaybe<FloatFieldComparison>;
  organization_id?: InputMaybe<IdFilterComparison>;
  parent_id?: InputMaybe<StringFieldComparison>;
  possible_value?: InputMaybe<DataTypeFilterComparison>;
  prediction_parallelization?: InputMaybe<NumberFieldComparison>;
  prediction_queue?: InputMaybe<StringFieldComparison>;
  prediction_timeout?: InputMaybe<NumberFieldComparison>;
  selection_mode?: InputMaybe<SelectionModeFilterComparison>;
  updated?: InputMaybe<DateFieldComparison>;
};

export type FloatFieldComparison = {
  between?: InputMaybe<FloatFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  neq?: InputMaybe<Scalars['Float']>;
  notBetween?: InputMaybe<FloatFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type FloatFieldComparisonBetween = {
  lower: Scalars['Float'];
  upper: Scalars['Float'];
};

export type IdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']>;
  gt?: InputMaybe<Scalars['ID']>;
  gte?: InputMaybe<Scalars['ID']>;
  iLike?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['ID']>;
  lt?: InputMaybe<Scalars['ID']>;
  lte?: InputMaybe<Scalars['ID']>;
  neq?: InputMaybe<Scalars['ID']>;
  notILike?: InputMaybe<Scalars['ID']>;
  notIn?: InputMaybe<Array<Scalars['ID']>>;
  notLike?: InputMaybe<Scalars['ID']>;
};

export type Log = {
  __typename?: 'Log';
  context?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['MyDateTime']>;
  entityClass?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  level: LogLevel;
  msg: Scalars['String'];
  user_email?: Maybe<Scalars['String']>;
};

export type LogAggregateGroupBy = {
  __typename?: 'LogAggregateGroupBy';
  context?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['MyDateTime']>;
  entityClass?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  level?: Maybe<LogLevel>;
};

export type LogAvgAggregate = {
  __typename?: 'LogAvgAggregate';
  level?: Maybe<Scalars['Float']>;
};

export type LogConnection = {
  __typename?: 'LogConnection';
  /** Array of edges. */
  edges: Array<LogEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int'];
};

export type LogCountAggregate = {
  __typename?: 'LogCountAggregate';
  context?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['Int']>;
  entityClass?: Maybe<Scalars['Int']>;
  entityId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['Int']>;
};

export type LogDeleteResponse = {
  __typename?: 'LogDeleteResponse';
  context?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['MyDateTime']>;
  entityClass?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  level?: Maybe<LogLevel>;
  msg?: Maybe<Scalars['String']>;
  user_email?: Maybe<Scalars['String']>;
};

export type LogEdge = {
  __typename?: 'LogEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the Log */
  node: Log;
};

export type LogFilter = {
  and?: InputMaybe<Array<LogFilter>>;
  context?: InputMaybe<StringFieldComparison>;
  created?: InputMaybe<DateFieldComparison>;
  entityClass?: InputMaybe<StringFieldComparison>;
  entityId?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  level?: InputMaybe<LogLevelFilterComparison>;
  or?: InputMaybe<Array<LogFilter>>;
};

export enum LogLevel {
  Debug = 'Debug',
  Error = 'Error',
  Info = 'Info',
  Verbose = 'Verbose',
  Warning = 'Warning'
}

export type LogLevelFilterComparison = {
  eq?: InputMaybe<LogLevel>;
  gt?: InputMaybe<LogLevel>;
  gte?: InputMaybe<LogLevel>;
  iLike?: InputMaybe<LogLevel>;
  in?: InputMaybe<Array<LogLevel>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<LogLevel>;
  lt?: InputMaybe<LogLevel>;
  lte?: InputMaybe<LogLevel>;
  neq?: InputMaybe<LogLevel>;
  notILike?: InputMaybe<LogLevel>;
  notIn?: InputMaybe<Array<LogLevel>>;
  notLike?: InputMaybe<LogLevel>;
};

export type LogMaxAggregate = {
  __typename?: 'LogMaxAggregate';
  context?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['MyDateTime']>;
  entityClass?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  level?: Maybe<LogLevel>;
};

export type LogMinAggregate = {
  __typename?: 'LogMinAggregate';
  context?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['MyDateTime']>;
  entityClass?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  level?: Maybe<LogLevel>;
};

export type LogSort = {
  direction: SortDirection;
  field: LogSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum LogSortFields {
  Context = 'context',
  Created = 'created',
  EntityClass = 'entityClass',
  EntityId = 'entityId',
  Id = 'id',
  Level = 'level'
}

export type LogSubscriptionFilter = {
  and?: InputMaybe<Array<LogSubscriptionFilter>>;
  context?: InputMaybe<StringFieldComparison>;
  created?: InputMaybe<DateFieldComparison>;
  entityClass?: InputMaybe<StringFieldComparison>;
  entityId?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  level?: InputMaybe<LogLevelFilterComparison>;
  or?: InputMaybe<Array<LogSubscriptionFilter>>;
};

export type LogSumAggregate = {
  __typename?: 'LogSumAggregate';
  level?: Maybe<Scalars['Float']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  changePassword: Scalars['Boolean'];
  createManyDocumentClasses: Array<DocumentClass>;
  createManyOrganizationMemberships: Array<OrganizationMembership>;
  createManyOrganizations: Array<Organization>;
  createOneDocumentClass: DocumentClass;
  createOneOrganization: Organization;
  createOneUser: User;
  deleteManyOrganizationMemberships: DeleteManyResponse;
  deleteManyRefreshTokens: DeleteManyResponse;
  deleteOneRefreshToken: RefreshTokenDeleteResponse;
  /** Note that this only performs a soft-delete. */
  deleteOneUser: User;
  registerRefreshToken: RefreshToken;
  updateManyDocumentClasses: UpdateManyResponse;
  updateManyOrganizationMemberships: UpdateManyResponse;
  updateManyOrganizations: UpdateManyResponse;
  updateManyUsers: UpdateManyResponse;
  updateOneDocumentClass: DocumentClass;
};


export type MutationChangePasswordArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationCreateManyDocumentClassesArgs = {
  input: CreateManyDocumentClassesInput;
};


export type MutationCreateManyOrganizationMembershipsArgs = {
  input: CreateManyOrganizationMembershipsInput;
};


export type MutationCreateManyOrganizationsArgs = {
  input: CreateManyOrganizationsInput;
};


export type MutationCreateOneDocumentClassArgs = {
  input: CreateOneDocumentClassInput;
};


export type MutationCreateOneOrganizationArgs = {
  input: CreateOneOrganizationInput;
};


export type MutationCreateOneUserArgs = {
  input: CreateOneUserInput;
};


export type MutationDeleteManyOrganizationMembershipsArgs = {
  input: DeleteManyOrganizationMembershipsInput;
};


export type MutationDeleteManyRefreshTokensArgs = {
  input: DeleteManyRefreshTokensInput;
};


export type MutationDeleteOneRefreshTokenArgs = {
  input: DeleteOneRefreshTokenInput;
};


export type MutationDeleteOneUserArgs = {
  email: Scalars['String'];
};


export type MutationRegisterRefreshTokenArgs = {
  refreshToken: RefreshTokenInput;
};


export type MutationUpdateManyDocumentClassesArgs = {
  input: UpdateManyDocumentClassesInput;
};


export type MutationUpdateManyOrganizationMembershipsArgs = {
  input: UpdateManyOrganizationMembershipsInput;
};


export type MutationUpdateManyOrganizationsArgs = {
  input: UpdateManyOrganizationsInput;
};


export type MutationUpdateManyUsersArgs = {
  input: UpdateManyUsersInput;
};


export type MutationUpdateOneDocumentClassArgs = {
  input: UpdateOneDocumentClassInput;
};

export type NumberFieldComparison = {
  between?: InputMaybe<NumberFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  neq?: InputMaybe<Scalars['Float']>;
  notBetween?: InputMaybe<NumberFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NumberFieldComparisonBetween = {
  lower: Scalars['Float'];
  upper: Scalars['Float'];
};

export type ObjectFilterComparison = {
  eq?: InputMaybe<Scalars['JSONString']>;
  gt?: InputMaybe<Scalars['JSONString']>;
  gte?: InputMaybe<Scalars['JSONString']>;
  iLike?: InputMaybe<Scalars['JSONString']>;
  in?: InputMaybe<Array<Scalars['JSONString']>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['JSONString']>;
  lt?: InputMaybe<Scalars['JSONString']>;
  lte?: InputMaybe<Scalars['JSONString']>;
  neq?: InputMaybe<Scalars['JSONString']>;
  notILike?: InputMaybe<Scalars['JSONString']>;
  notIn?: InputMaybe<Array<Scalars['JSONString']>>;
  notLike?: InputMaybe<Scalars['JSONString']>;
};

export type Organization = {
  __typename?: 'Organization';
  created?: Maybe<Scalars['MyDateTime']>;
  /** Stores the menu configuration for different document categories (e.g. classification, extraction, verification, etc...) */
  frontend_category_settings?: Maybe<Scalars['JSONString']>;
  identifier: Scalars['String'];
  name: Scalars['String'];
  organization_memberships?: Maybe<Array<OrganizationMembership>>;
  show_freshdesk_widget: Scalars['Boolean'];
  updated?: Maybe<Scalars['MyDateTime']>;
  users: OrganizationUsersConnection;
  usersAggregate: Array<OrganizationUsersAggregateResponse>;
};


export type OrganizationOrganization_MembershipsArgs = {
  filter?: InputMaybe<OrganizationMembershipFilter>;
  sorting?: InputMaybe<Array<OrganizationMembershipSort>>;
};


export type OrganizationUsersArgs = {
  filter?: InputMaybe<UserFilter>;
  paging?: InputMaybe<CursorPaging>;
  sorting?: InputMaybe<Array<UserSort>>;
};


export type OrganizationUsersAggregateArgs = {
  filter?: InputMaybe<UserAggregateFilter>;
};

export type OrganizationAggregateGroupBy = {
  __typename?: 'OrganizationAggregateGroupBy';
  created?: Maybe<Scalars['MyDateTime']>;
  identifier?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  show_freshdesk_widget?: Maybe<Scalars['Boolean']>;
  updated?: Maybe<Scalars['MyDateTime']>;
};

export type OrganizationCountAggregate = {
  __typename?: 'OrganizationCountAggregate';
  created?: Maybe<Scalars['Int']>;
  identifier?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
  show_freshdesk_widget?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['Int']>;
};

export type OrganizationDeleteResponse = {
  __typename?: 'OrganizationDeleteResponse';
  created?: Maybe<Scalars['MyDateTime']>;
  /** Stores the menu configuration for different document categories (e.g. classification, extraction, verification, etc...) */
  frontend_category_settings?: Maybe<Scalars['JSONString']>;
  identifier?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  show_freshdesk_widget?: Maybe<Scalars['Boolean']>;
  updated?: Maybe<Scalars['MyDateTime']>;
};

export type OrganizationFilter = {
  and?: InputMaybe<Array<OrganizationFilter>>;
  created?: InputMaybe<DateFieldComparison>;
  identifier?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<OrganizationFilter>>;
  show_freshdesk_widget?: InputMaybe<BooleanFieldComparison>;
  updated?: InputMaybe<DateFieldComparison>;
  users?: InputMaybe<OrganizationFilterUserFilter>;
};

export type OrganizationFilterUserFilter = {
  and?: InputMaybe<Array<OrganizationFilterUserFilter>>;
  created?: InputMaybe<DateFieldComparison>;
  deleted?: InputMaybe<DateFieldComparison>;
  email?: InputMaybe<StringFieldComparison>;
  last_login?: InputMaybe<DateFieldComparison>;
  login_disabled?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<OrganizationFilterUserFilter>>;
  updated?: InputMaybe<DateFieldComparison>;
};

export type OrganizationMaxAggregate = {
  __typename?: 'OrganizationMaxAggregate';
  created?: Maybe<Scalars['MyDateTime']>;
  identifier?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['MyDateTime']>;
};

export type OrganizationMembership = {
  __typename?: 'OrganizationMembership';
  created: Scalars['MyDateTime'];
  organization: Organization;
  organization_id: Scalars['String'];
  roles: Array<OrganizationRole>;
  updated: Scalars['MyDateTime'];
  user: User;
  user_email: Scalars['String'];
};

export type OrganizationMembershipAggregateGroupBy = {
  __typename?: 'OrganizationMembershipAggregateGroupBy';
  created?: Maybe<Scalars['MyDateTime']>;
  organization_id?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['MyDateTime']>;
  user_email?: Maybe<Scalars['String']>;
};

export type OrganizationMembershipConnection = {
  __typename?: 'OrganizationMembershipConnection';
  /** Array of edges. */
  edges: Array<OrganizationMembershipEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int'];
};

export type OrganizationMembershipCountAggregate = {
  __typename?: 'OrganizationMembershipCountAggregate';
  created?: Maybe<Scalars['Int']>;
  organization_id?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['Int']>;
  user_email?: Maybe<Scalars['Int']>;
};

export type OrganizationMembershipDeleteFilter = {
  and?: InputMaybe<Array<OrganizationMembershipDeleteFilter>>;
  created?: InputMaybe<DateFieldComparison>;
  or?: InputMaybe<Array<OrganizationMembershipDeleteFilter>>;
  organization_id?: InputMaybe<StringFieldComparison>;
  updated?: InputMaybe<DateFieldComparison>;
  user_email?: InputMaybe<StringFieldComparison>;
};

export type OrganizationMembershipDeleteResponse = {
  __typename?: 'OrganizationMembershipDeleteResponse';
  created?: Maybe<Scalars['MyDateTime']>;
  organization_id?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<OrganizationRole>>;
  updated?: Maybe<Scalars['MyDateTime']>;
  user_email?: Maybe<Scalars['String']>;
};

export type OrganizationMembershipEdge = {
  __typename?: 'OrganizationMembershipEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the OrganizationMembership */
  node: OrganizationMembership;
};

export type OrganizationMembershipFilter = {
  and?: InputMaybe<Array<OrganizationMembershipFilter>>;
  created?: InputMaybe<DateFieldComparison>;
  or?: InputMaybe<Array<OrganizationMembershipFilter>>;
  organization_id?: InputMaybe<StringFieldComparison>;
  updated?: InputMaybe<DateFieldComparison>;
  user_email?: InputMaybe<StringFieldComparison>;
};

export type OrganizationMembershipMaxAggregate = {
  __typename?: 'OrganizationMembershipMaxAggregate';
  created?: Maybe<Scalars['MyDateTime']>;
  organization_id?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['MyDateTime']>;
  user_email?: Maybe<Scalars['String']>;
};

export type OrganizationMembershipMinAggregate = {
  __typename?: 'OrganizationMembershipMinAggregate';
  created?: Maybe<Scalars['MyDateTime']>;
  organization_id?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['MyDateTime']>;
  user_email?: Maybe<Scalars['String']>;
};

export type OrganizationMembershipSort = {
  direction: SortDirection;
  field: OrganizationMembershipSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum OrganizationMembershipSortFields {
  Created = 'created',
  OrganizationId = 'organization_id',
  Updated = 'updated',
  UserEmail = 'user_email'
}

export type OrganizationMembershipSubscriptionFilter = {
  and?: InputMaybe<Array<OrganizationMembershipSubscriptionFilter>>;
  created?: InputMaybe<DateFieldComparison>;
  or?: InputMaybe<Array<OrganizationMembershipSubscriptionFilter>>;
  organization_id?: InputMaybe<StringFieldComparison>;
  updated?: InputMaybe<DateFieldComparison>;
  user_email?: InputMaybe<StringFieldComparison>;
};

export type OrganizationMembershipUpdateFilter = {
  and?: InputMaybe<Array<OrganizationMembershipUpdateFilter>>;
  created?: InputMaybe<DateFieldComparison>;
  or?: InputMaybe<Array<OrganizationMembershipUpdateFilter>>;
  organization_id?: InputMaybe<StringFieldComparison>;
  updated?: InputMaybe<DateFieldComparison>;
  user_email?: InputMaybe<StringFieldComparison>;
};

export type OrganizationMinAggregate = {
  __typename?: 'OrganizationMinAggregate';
  created?: Maybe<Scalars['MyDateTime']>;
  identifier?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['MyDateTime']>;
};

export enum OrganizationRole {
  Importer = 'Importer',
  Labeler = 'Labeler',
  OrganizationAdmin = 'OrganizationAdmin',
  Verifier = 'Verifier'
}

export type OrganizationSort = {
  direction: SortDirection;
  field: OrganizationSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum OrganizationSortFields {
  Created = 'created',
  Identifier = 'identifier',
  Name = 'name',
  ShowFreshdeskWidget = 'show_freshdesk_widget',
  Updated = 'updated'
}

export type OrganizationSubscriptionFilter = {
  and?: InputMaybe<Array<OrganizationSubscriptionFilter>>;
  created?: InputMaybe<DateFieldComparison>;
  identifier?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<OrganizationSubscriptionFilter>>;
  show_freshdesk_widget?: InputMaybe<BooleanFieldComparison>;
  updated?: InputMaybe<DateFieldComparison>;
};

export type OrganizationUpdateFilter = {
  and?: InputMaybe<Array<OrganizationUpdateFilter>>;
  created?: InputMaybe<DateFieldComparison>;
  identifier?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<OrganizationUpdateFilter>>;
  show_freshdesk_widget?: InputMaybe<BooleanFieldComparison>;
  updated?: InputMaybe<DateFieldComparison>;
};

export type OrganizationUsersAggregateGroupBy = {
  __typename?: 'OrganizationUsersAggregateGroupBy';
  created?: Maybe<Scalars['MyDateTime']>;
  deleted?: Maybe<Scalars['MyDateTime']>;
  email?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['MyDateTime']>;
  login_disabled?: Maybe<Scalars['Boolean']>;
  updated?: Maybe<Scalars['MyDateTime']>;
};

export type OrganizationUsersAggregateResponse = {
  __typename?: 'OrganizationUsersAggregateResponse';
  count?: Maybe<OrganizationUsersCountAggregate>;
  groupBy?: Maybe<OrganizationUsersAggregateGroupBy>;
  max?: Maybe<OrganizationUsersMaxAggregate>;
  min?: Maybe<OrganizationUsersMinAggregate>;
};

export type OrganizationUsersConnection = {
  __typename?: 'OrganizationUsersConnection';
  /** Array of edges. */
  edges: Array<UserEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int'];
};

export type OrganizationUsersCountAggregate = {
  __typename?: 'OrganizationUsersCountAggregate';
  created?: Maybe<Scalars['Int']>;
  deleted?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['Int']>;
  last_login?: Maybe<Scalars['Int']>;
  login_disabled?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['Int']>;
};

export type OrganizationUsersMaxAggregate = {
  __typename?: 'OrganizationUsersMaxAggregate';
  created?: Maybe<Scalars['MyDateTime']>;
  deleted?: Maybe<Scalars['MyDateTime']>;
  email?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['MyDateTime']>;
  updated?: Maybe<Scalars['MyDateTime']>;
};

export type OrganizationUsersMinAggregate = {
  __typename?: 'OrganizationUsersMinAggregate';
  created?: Maybe<Scalars['MyDateTime']>;
  deleted?: Maybe<Scalars['MyDateTime']>;
  email?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['MyDateTime']>;
  updated?: Maybe<Scalars['MyDateTime']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor of the last returned record. */
  endCursor?: Maybe<Scalars['ConnectionCursor']>;
  /** true if paging forward and there are more records. */
  hasNextPage?: Maybe<Scalars['Boolean']>;
  /** true if paging backwards and there are more records. */
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  /** The cursor of the first returned record. */
  startCursor?: Maybe<Scalars['ConnectionCursor']>;
};

export enum PlatformRole {
  Developer = 'Developer',
  Internal = 'Internal',
  PlatformAdmin = 'PlatformAdmin'
}

export type Query = {
  __typename?: 'Query';
  documentClass?: Maybe<DocumentClass>;
  documentClassByIdentifier: DocumentClass;
  documentClasses: DocumentClassConnection;
  documentClassesByRegex: DocumentClassConnection;
  log?: Maybe<Log>;
  logs: LogConnection;
  organization?: Maybe<Organization>;
  organizationByIdentifier: Organization;
  organizationMembership?: Maybe<OrganizationMembership>;
  organizationMemberships: OrganizationMembershipConnection;
  organizations: Array<Organization>;
  refreshToken?: Maybe<RefreshToken>;
  refreshTokens: RefreshTokenConnection;
  user?: Maybe<User>;
  users: UserConnection;
};


export type QueryDocumentClassArgs = {
  id: Scalars['String'];
};


export type QueryDocumentClassByIdentifierArgs = {
  identifier: Scalars['String'];
};


export type QueryDocumentClassesArgs = {
  filter?: InputMaybe<DocumentClassFilter>;
  paging?: InputMaybe<CursorPaging>;
  sorting?: InputMaybe<Array<DocumentClassSort>>;
};


export type QueryDocumentClassesByRegexArgs = {
  filter?: InputMaybe<DocumentClassFilter>;
  paging?: InputMaybe<CursorPaging>;
  regex: Scalars['String'];
  sorting?: InputMaybe<Array<DocumentClassSort>>;
};


export type QueryLogArgs = {
  id: Scalars['ID'];
};


export type QueryLogsArgs = {
  filter?: InputMaybe<LogFilter>;
  paging?: InputMaybe<CursorPaging>;
  sorting?: InputMaybe<Array<LogSort>>;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID'];
};


export type QueryOrganizationByIdentifierArgs = {
  identifier: Scalars['String'];
};


export type QueryOrganizationMembershipArgs = {
  id: Scalars['ID'];
};


export type QueryOrganizationMembershipsArgs = {
  filter?: InputMaybe<OrganizationMembershipFilter>;
  paging?: InputMaybe<CursorPaging>;
  sorting?: InputMaybe<Array<OrganizationMembershipSort>>;
};


export type QueryOrganizationsArgs = {
  filter?: InputMaybe<OrganizationFilter>;
  sorting?: InputMaybe<Array<OrganizationSort>>;
};


export type QueryRefreshTokenArgs = {
  id: Scalars['String'];
};


export type QueryRefreshTokensArgs = {
  filter?: InputMaybe<RefreshTokenFilter>;
  paging?: InputMaybe<CursorPaging>;
  sorting?: InputMaybe<Array<RefreshTokenSort>>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUsersArgs = {
  filter?: InputMaybe<UserFilter>;
  paging?: InputMaybe<CursorPaging>;
  sorting?: InputMaybe<Array<UserSort>>;
};

export type RefreshToken = {
  __typename?: 'RefreshToken';
  created?: Maybe<Scalars['MyDateTime']>;
  expires_at?: Maybe<Scalars['MyDateTime']>;
  id: Scalars['String'];
  issued_at?: Maybe<Scalars['MyDateTime']>;
  updated?: Maybe<Scalars['MyDateTime']>;
  user: User;
  user_email: Scalars['String'];
};

export type RefreshTokenAggregateGroupBy = {
  __typename?: 'RefreshTokenAggregateGroupBy';
  created?: Maybe<Scalars['MyDateTime']>;
  expires_at?: Maybe<Scalars['MyDateTime']>;
  id?: Maybe<Scalars['String']>;
  issued_at?: Maybe<Scalars['MyDateTime']>;
  updated?: Maybe<Scalars['MyDateTime']>;
  user_email?: Maybe<Scalars['String']>;
};

export type RefreshTokenConnection = {
  __typename?: 'RefreshTokenConnection';
  /** Array of edges. */
  edges: Array<RefreshTokenEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int'];
};

export type RefreshTokenCountAggregate = {
  __typename?: 'RefreshTokenCountAggregate';
  created?: Maybe<Scalars['Int']>;
  expires_at?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  issued_at?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['Int']>;
  user_email?: Maybe<Scalars['Int']>;
};

export type RefreshTokenDeleteFilter = {
  and?: InputMaybe<Array<RefreshTokenDeleteFilter>>;
  created?: InputMaybe<DateFieldComparison>;
  expires_at?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  issued_at?: InputMaybe<DateFieldComparison>;
  or?: InputMaybe<Array<RefreshTokenDeleteFilter>>;
  updated?: InputMaybe<DateFieldComparison>;
  user_email?: InputMaybe<StringFieldComparison>;
};

export type RefreshTokenDeleteResponse = {
  __typename?: 'RefreshTokenDeleteResponse';
  created?: Maybe<Scalars['MyDateTime']>;
  expires_at?: Maybe<Scalars['MyDateTime']>;
  id?: Maybe<Scalars['String']>;
  issued_at?: Maybe<Scalars['MyDateTime']>;
  updated?: Maybe<Scalars['MyDateTime']>;
  user_email?: Maybe<Scalars['String']>;
};

export type RefreshTokenEdge = {
  __typename?: 'RefreshTokenEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the RefreshToken */
  node: RefreshToken;
};

export type RefreshTokenFilter = {
  and?: InputMaybe<Array<RefreshTokenFilter>>;
  created?: InputMaybe<DateFieldComparison>;
  expires_at?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  issued_at?: InputMaybe<DateFieldComparison>;
  or?: InputMaybe<Array<RefreshTokenFilter>>;
  updated?: InputMaybe<DateFieldComparison>;
  user_email?: InputMaybe<StringFieldComparison>;
};

export type RefreshTokenInput = {
  created?: InputMaybe<Scalars['MyDateTime']>;
  expires_at?: InputMaybe<Scalars['MyDateTime']>;
  id: Scalars['String'];
  issued_at?: InputMaybe<Scalars['MyDateTime']>;
  updated?: InputMaybe<Scalars['MyDateTime']>;
  user_email: Scalars['String'];
};

export type RefreshTokenMaxAggregate = {
  __typename?: 'RefreshTokenMaxAggregate';
  created?: Maybe<Scalars['MyDateTime']>;
  expires_at?: Maybe<Scalars['MyDateTime']>;
  id?: Maybe<Scalars['String']>;
  issued_at?: Maybe<Scalars['MyDateTime']>;
  updated?: Maybe<Scalars['MyDateTime']>;
  user_email?: Maybe<Scalars['String']>;
};

export type RefreshTokenMinAggregate = {
  __typename?: 'RefreshTokenMinAggregate';
  created?: Maybe<Scalars['MyDateTime']>;
  expires_at?: Maybe<Scalars['MyDateTime']>;
  id?: Maybe<Scalars['String']>;
  issued_at?: Maybe<Scalars['MyDateTime']>;
  updated?: Maybe<Scalars['MyDateTime']>;
  user_email?: Maybe<Scalars['String']>;
};

export type RefreshTokenSort = {
  direction: SortDirection;
  field: RefreshTokenSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum RefreshTokenSortFields {
  Created = 'created',
  ExpiresAt = 'expires_at',
  Id = 'id',
  IssuedAt = 'issued_at',
  Updated = 'updated',
  UserEmail = 'user_email'
}

export type RefreshTokenSubscriptionFilter = {
  and?: InputMaybe<Array<RefreshTokenSubscriptionFilter>>;
  created?: InputMaybe<DateFieldComparison>;
  expires_at?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  issued_at?: InputMaybe<DateFieldComparison>;
  or?: InputMaybe<Array<RefreshTokenSubscriptionFilter>>;
  updated?: InputMaybe<DateFieldComparison>;
  user_email?: InputMaybe<StringFieldComparison>;
};

export type RegexValidator = {
  __typename?: 'RegexValidator';
  error_message: Scalars['String'];
  pattern: Scalars['String'];
};

export type RegexValidatorInput = {
  error_message: Scalars['String'];
  pattern: Scalars['String'];
};

export enum SelectionMode {
  Anything = 'Anything',
  Cutout = 'Cutout',
  Page = 'Page',
  Pages = 'Pages',
  Parent = 'Parent'
}

export type SelectionModeFilterComparison = {
  eq?: InputMaybe<SelectionMode>;
  gt?: InputMaybe<SelectionMode>;
  gte?: InputMaybe<SelectionMode>;
  iLike?: InputMaybe<SelectionMode>;
  in?: InputMaybe<Array<SelectionMode>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<SelectionMode>;
  lt?: InputMaybe<SelectionMode>;
  lte?: InputMaybe<SelectionMode>;
  neq?: InputMaybe<SelectionMode>;
  notILike?: InputMaybe<SelectionMode>;
  notIn?: InputMaybe<Array<SelectionMode>>;
  notLike?: InputMaybe<SelectionMode>;
};

/** Sort Directions */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Sort Nulls Options */
export enum SortNulls {
  NullsFirst = 'NULLS_FIRST',
  NullsLast = 'NULLS_LAST'
}

export type StringFieldComparison = {
  eq?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  iLike?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['String']>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  neq?: InputMaybe<Scalars['String']>;
  notILike?: InputMaybe<Scalars['String']>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  notLike?: InputMaybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  createdDocumentClass: DocumentClass;
  createdLog: Log;
  createdOrganization: Organization;
  createdOrganizationMembership: OrganizationMembership;
  createdRefreshToken: RefreshToken;
  createdUser: User;
  deletedManyDocumentClasses: DeleteManyResponse;
  deletedManyLogs: DeleteManyResponse;
  deletedManyOrganizationMemberships: DeleteManyResponse;
  deletedManyOrganizations: DeleteManyResponse;
  deletedManyRefreshTokens: DeleteManyResponse;
  deletedManyUsers: DeleteManyResponse;
  deletedOneDocumentClass: DocumentClassDeleteResponse;
  deletedOneLog: LogDeleteResponse;
  deletedOneOrganization: OrganizationDeleteResponse;
  deletedOneOrganizationMembership: OrganizationMembershipDeleteResponse;
  deletedOneRefreshToken: RefreshTokenDeleteResponse;
  deletedOneUser: UserDeleteResponse;
  updatedManyDocumentClasses: UpdateManyResponse;
  updatedManyLogs: UpdateManyResponse;
  updatedManyOrganizationMemberships: UpdateManyResponse;
  updatedManyOrganizations: UpdateManyResponse;
  updatedManyRefreshTokens: UpdateManyResponse;
  updatedManyUsers: UpdateManyResponse;
  updatedOneDocumentClass: DocumentClass;
  updatedOneLog: Log;
  updatedOneOrganization: Organization;
  updatedOneOrganizationMembership: OrganizationMembership;
  updatedOneRefreshToken: RefreshToken;
  updatedOneUser: User;
};


export type SubscriptionCreatedDocumentClassArgs = {
  input?: InputMaybe<CreateDocumentClassSubscriptionFilterInput>;
};


export type SubscriptionCreatedLogArgs = {
  input?: InputMaybe<CreateLogSubscriptionFilterInput>;
};


export type SubscriptionCreatedOrganizationArgs = {
  input?: InputMaybe<CreateOrganizationSubscriptionFilterInput>;
};


export type SubscriptionCreatedOrganizationMembershipArgs = {
  input?: InputMaybe<CreateOrganizationMembershipSubscriptionFilterInput>;
};


export type SubscriptionCreatedRefreshTokenArgs = {
  input?: InputMaybe<CreateRefreshTokenSubscriptionFilterInput>;
};


export type SubscriptionCreatedUserArgs = {
  input?: InputMaybe<CreateUserSubscriptionFilterInput>;
};


export type SubscriptionDeletedOneDocumentClassArgs = {
  input?: InputMaybe<DeleteOneDocumentClassSubscriptionFilterInput>;
};


export type SubscriptionDeletedOneLogArgs = {
  input?: InputMaybe<DeleteOneLogSubscriptionFilterInput>;
};


export type SubscriptionDeletedOneOrganizationArgs = {
  input?: InputMaybe<DeleteOneOrganizationSubscriptionFilterInput>;
};


export type SubscriptionDeletedOneOrganizationMembershipArgs = {
  input?: InputMaybe<DeleteOneOrganizationMembershipSubscriptionFilterInput>;
};


export type SubscriptionDeletedOneRefreshTokenArgs = {
  input?: InputMaybe<DeleteOneRefreshTokenSubscriptionFilterInput>;
};


export type SubscriptionDeletedOneUserArgs = {
  input?: InputMaybe<DeleteOneUserSubscriptionFilterInput>;
};


export type SubscriptionUpdatedOneDocumentClassArgs = {
  input?: InputMaybe<UpdateOneDocumentClassSubscriptionFilterInput>;
};


export type SubscriptionUpdatedOneLogArgs = {
  input?: InputMaybe<UpdateOneLogSubscriptionFilterInput>;
};


export type SubscriptionUpdatedOneOrganizationArgs = {
  input?: InputMaybe<UpdateOneOrganizationSubscriptionFilterInput>;
};


export type SubscriptionUpdatedOneOrganizationMembershipArgs = {
  input?: InputMaybe<UpdateOneOrganizationMembershipSubscriptionFilterInput>;
};


export type SubscriptionUpdatedOneRefreshTokenArgs = {
  input?: InputMaybe<UpdateOneRefreshTokenSubscriptionFilterInput>;
};


export type SubscriptionUpdatedOneUserArgs = {
  input?: InputMaybe<UpdateOneUserSubscriptionFilterInput>;
};

export type UpdateManyDocumentClassesInput = {
  /** Filter used to find fields to update */
  filter: DocumentClassUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: DocumentClassUpdateDto;
};

export type UpdateManyOrganizationMembershipsInput = {
  /** Filter used to find fields to update */
  filter: OrganizationMembershipUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateOrganizationMembership;
};

export type UpdateManyOrganizationsInput = {
  /** Filter used to find fields to update */
  filter: OrganizationUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateOrganization;
};

export type UpdateManyResponse = {
  __typename?: 'UpdateManyResponse';
  /** The number of records updated. */
  updatedCount: Scalars['Int'];
};

export type UpdateManyUsersInput = {
  /** Filter used to find fields to update */
  filter: UserUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UserUpdateInput;
};

export type UpdateOneDocumentClassInput = {
  /** The id of the record to update */
  id: Scalars['String'];
  /** The update to apply. */
  update: DocumentClassUpdateDto;
};

export type UpdateOneDocumentClassSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: DocumentClassSubscriptionFilter;
};

export type UpdateOneLogSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: LogSubscriptionFilter;
};

export type UpdateOneOrganizationMembershipSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: OrganizationMembershipSubscriptionFilter;
};

export type UpdateOneOrganizationSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: OrganizationSubscriptionFilter;
};

export type UpdateOneRefreshTokenSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: RefreshTokenSubscriptionFilter;
};

export type UpdateOneUserSubscriptionFilterInput = {
  /** Specify to filter the records returned. */
  filter: UserSubscriptionFilter;
};

export type UpdateOrganization = {
  created?: InputMaybe<Scalars['MyDateTime']>;
  /** Stores the menu configuration for different document categories (e.g. classification, extraction, verification, etc...) */
  frontend_category_settings?: InputMaybe<Scalars['JSONString']>;
  identifier?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  show_freshdesk_widget?: InputMaybe<Scalars['Boolean']>;
  updated?: InputMaybe<Scalars['MyDateTime']>;
};

export type UpdateOrganizationMembership = {
  created?: InputMaybe<Scalars['MyDateTime']>;
  organization_id?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<OrganizationRole>>;
  updated?: InputMaybe<Scalars['MyDateTime']>;
  user_email?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  created?: Maybe<Scalars['MyDateTime']>;
  deleted?: Maybe<Scalars['MyDateTime']>;
  email: Scalars['String'];
  first_name?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['MyDateTime']>;
  last_name?: Maybe<Scalars['String']>;
  login_disabled: Scalars['Boolean'];
  name: Scalars['String'];
  organization_memberships: Array<OrganizationMembership>;
  password_hash: Scalars['String'];
  platform_roles: Array<PlatformRole>;
  refresh_tokens: Array<RefreshToken>;
  updated?: Maybe<Scalars['MyDateTime']>;
};


export type UserOrganization_MembershipsArgs = {
  filter?: InputMaybe<OrganizationMembershipFilter>;
  sorting?: InputMaybe<Array<OrganizationMembershipSort>>;
};


export type UserRefresh_TokensArgs = {
  filter?: InputMaybe<RefreshTokenFilter>;
  sorting?: InputMaybe<Array<RefreshTokenSort>>;
};

export type UserAggregateFilter = {
  and?: InputMaybe<Array<UserAggregateFilter>>;
  created?: InputMaybe<DateFieldComparison>;
  deleted?: InputMaybe<DateFieldComparison>;
  email?: InputMaybe<StringFieldComparison>;
  last_login?: InputMaybe<DateFieldComparison>;
  login_disabled?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<UserAggregateFilter>>;
  updated?: InputMaybe<DateFieldComparison>;
};

export type UserAggregateGroupBy = {
  __typename?: 'UserAggregateGroupBy';
  created?: Maybe<Scalars['MyDateTime']>;
  deleted?: Maybe<Scalars['MyDateTime']>;
  email?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['MyDateTime']>;
  login_disabled?: Maybe<Scalars['Boolean']>;
  updated?: Maybe<Scalars['MyDateTime']>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  /** Array of edges. */
  edges: Array<UserEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int'];
};

export type UserCountAggregate = {
  __typename?: 'UserCountAggregate';
  created?: Maybe<Scalars['Int']>;
  deleted?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['Int']>;
  last_login?: Maybe<Scalars['Int']>;
  login_disabled?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['Int']>;
};

export type UserCreateInput = {
  email: Scalars['String'];
  first_name?: InputMaybe<Scalars['String']>;
  last_login?: InputMaybe<Scalars['MyDateTime']>;
  last_name?: InputMaybe<Scalars['String']>;
  login_disabled?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  platform_roles?: InputMaybe<Array<PlatformRole>>;
};

export type UserDeleteResponse = {
  __typename?: 'UserDeleteResponse';
  created?: Maybe<Scalars['MyDateTime']>;
  deleted?: Maybe<Scalars['MyDateTime']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['MyDateTime']>;
  last_name?: Maybe<Scalars['String']>;
  login_disabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  password_hash?: Maybe<Scalars['String']>;
  platform_roles?: Maybe<Array<PlatformRole>>;
  updated?: Maybe<Scalars['MyDateTime']>;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the User */
  node: User;
};

export type UserFilter = {
  and?: InputMaybe<Array<UserFilter>>;
  created?: InputMaybe<DateFieldComparison>;
  deleted?: InputMaybe<DateFieldComparison>;
  email?: InputMaybe<StringFieldComparison>;
  last_login?: InputMaybe<DateFieldComparison>;
  login_disabled?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<UserFilter>>;
  updated?: InputMaybe<DateFieldComparison>;
};

export type UserMaxAggregate = {
  __typename?: 'UserMaxAggregate';
  created?: Maybe<Scalars['MyDateTime']>;
  deleted?: Maybe<Scalars['MyDateTime']>;
  email?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['MyDateTime']>;
  updated?: Maybe<Scalars['MyDateTime']>;
};

export type UserMinAggregate = {
  __typename?: 'UserMinAggregate';
  created?: Maybe<Scalars['MyDateTime']>;
  deleted?: Maybe<Scalars['MyDateTime']>;
  email?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['MyDateTime']>;
  updated?: Maybe<Scalars['MyDateTime']>;
};

export type UserSort = {
  direction: SortDirection;
  field: UserSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum UserSortFields {
  Created = 'created',
  Deleted = 'deleted',
  Email = 'email',
  LastLogin = 'last_login',
  LoginDisabled = 'login_disabled',
  Updated = 'updated'
}

export type UserSubscriptionFilter = {
  and?: InputMaybe<Array<UserSubscriptionFilter>>;
  created?: InputMaybe<DateFieldComparison>;
  deleted?: InputMaybe<DateFieldComparison>;
  email?: InputMaybe<StringFieldComparison>;
  last_login?: InputMaybe<DateFieldComparison>;
  login_disabled?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<UserSubscriptionFilter>>;
  updated?: InputMaybe<DateFieldComparison>;
};

export type UserUpdateFilter = {
  and?: InputMaybe<Array<UserUpdateFilter>>;
  created?: InputMaybe<DateFieldComparison>;
  deleted?: InputMaybe<DateFieldComparison>;
  email?: InputMaybe<StringFieldComparison>;
  last_login?: InputMaybe<DateFieldComparison>;
  login_disabled?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<UserUpdateFilter>>;
  updated?: InputMaybe<DateFieldComparison>;
};

export type UserUpdateInput = {
  first_name?: InputMaybe<Scalars['String']>;
  last_login?: InputMaybe<Scalars['MyDateTime']>;
  last_name?: InputMaybe<Scalars['String']>;
  login_disabled?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  platform_roles?: InputMaybe<Array<PlatformRole>>;
};

export type SimpleDocumentClassFragmentFragment = { __typename?: 'DocumentClass', identifier: string, local_identifier: string, display_name: string };

export type DocumentClassFragmentFragment = { __typename?: 'DocumentClass', identifier: string, local_identifier: string, display_name: string, selection_mode: SelectionMode, parent_id?: string | null, identifier_by_organization?: string | null, organization_id: string, description?: string | null, auto_predictor_mode: AutoPredictorMode, possible_value?: DataType | null, min_count?: number | null, max_count?: number | null, min_page_count?: number | null, max_page_count?: number | null, may_overlap_with_siblings?: boolean | null, order_weight?: number | null, always_include_in_blind_processing_decision: boolean, export_enabled?: boolean | null, comments?: string | null, created: Date, updated: Date, category?: string | null, exporter_settings?: object | null, exporter_settings_schema?: object | null, deleted_at?: Date | null, export_timeout?: number | null, export_parallelization?: number | null, export_queue?: string | null, prediction_queue?: string | null, search_keywords?: Array<string> | null, blind_processing_thresholds?: Array<{ __typename?: 'BlindProcessingThreshold', confirmedness: number, score: number }> | null, regex_validators: Array<{ __typename?: 'RegexValidator', pattern: string, error_message: string }> };

export type FullDocumentClassFragmentFragment = { __typename?: 'DocumentClass', parent?: { __typename?: 'DocumentClass', identifier: string, local_identifier: string, display_name: string, selection_mode: SelectionMode, parent_id?: string | null, identifier_by_organization?: string | null, organization_id: string, description?: string | null, auto_predictor_mode: AutoPredictorMode, possible_value?: DataType | null, min_count?: number | null, max_count?: number | null, min_page_count?: number | null, max_page_count?: number | null, may_overlap_with_siblings?: boolean | null, order_weight?: number | null, always_include_in_blind_processing_decision: boolean, export_enabled?: boolean | null, comments?: string | null, created: Date, updated: Date, category?: string | null, exporter_settings?: object | null, exporter_settings_schema?: object | null, deleted_at?: Date | null, export_timeout?: number | null, export_parallelization?: number | null, export_queue?: string | null, prediction_queue?: string | null, search_keywords?: Array<string> | null, blind_processing_thresholds?: Array<{ __typename?: 'BlindProcessingThreshold', confirmedness: number, score: number }> | null, regex_validators: Array<{ __typename?: 'RegexValidator', pattern: string, error_message: string }> } | null, children?: { __typename?: 'DocumentClassChildrenConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: any | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: any | null }, edges: Array<{ __typename?: 'DocumentClassEdge', cursor: any, node: { __typename?: 'DocumentClass', identifier: string, local_identifier: string, display_name: string, selection_mode: SelectionMode, parent_id?: string | null, identifier_by_organization?: string | null, organization_id: string, description?: string | null, auto_predictor_mode: AutoPredictorMode, possible_value?: DataType | null, min_count?: number | null, max_count?: number | null, min_page_count?: number | null, max_page_count?: number | null, may_overlap_with_siblings?: boolean | null, order_weight?: number | null, always_include_in_blind_processing_decision: boolean, export_enabled?: boolean | null, comments?: string | null, created: Date, updated: Date, category?: string | null, exporter_settings?: object | null, exporter_settings_schema?: object | null, deleted_at?: Date | null, export_timeout?: number | null, export_parallelization?: number | null, export_queue?: string | null, prediction_queue?: string | null, search_keywords?: Array<string> | null, blind_processing_thresholds?: Array<{ __typename?: 'BlindProcessingThreshold', confirmedness: number, score: number }> | null, regex_validators: Array<{ __typename?: 'RegexValidator', pattern: string, error_message: string }> } }> } | null };

export type DocumentClassesQueryVariables = Exact<{
  filter: DocumentClassFilter;
  paging?: InputMaybe<CursorPaging>;
  sorting?: InputMaybe<Array<DocumentClassSort> | DocumentClassSort>;
  withDetail?: InputMaybe<Scalars['Boolean']>;
  simple?: InputMaybe<Scalars['Boolean']>;
  childrenFilter?: InputMaybe<DocumentClassFilter>;
}>;


export type DocumentClassesQuery = { __typename?: 'Query', documentClasses: { __typename?: 'DocumentClassConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: any | null, endCursor?: any | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, edges: Array<{ __typename?: 'DocumentClassEdge', cursor: any, node: { __typename?: 'DocumentClass', identifier: string, local_identifier: string, display_name: string, selection_mode: SelectionMode, parent_id?: string | null, identifier_by_organization?: string | null, organization_id: string, description?: string | null, auto_predictor_mode: AutoPredictorMode, possible_value?: DataType | null, min_count?: number | null, max_count?: number | null, min_page_count?: number | null, max_page_count?: number | null, may_overlap_with_siblings?: boolean | null, order_weight?: number | null, always_include_in_blind_processing_decision: boolean, export_enabled?: boolean | null, comments?: string | null, created: Date, updated: Date, category?: string | null, exporter_settings?: object | null, exporter_settings_schema?: object | null, deleted_at?: Date | null, export_timeout?: number | null, export_parallelization?: number | null, export_queue?: string | null, prediction_queue?: string | null, search_keywords?: Array<string> | null, blind_processing_thresholds?: Array<{ __typename?: 'BlindProcessingThreshold', confirmedness: number, score: number }> | null, regex_validators: Array<{ __typename?: 'RegexValidator', pattern: string, error_message: string }>, parent?: { __typename?: 'DocumentClass', identifier: string, local_identifier: string, display_name: string, selection_mode: SelectionMode, parent_id?: string | null, identifier_by_organization?: string | null, organization_id: string, description?: string | null, auto_predictor_mode: AutoPredictorMode, possible_value?: DataType | null, min_count?: number | null, max_count?: number | null, min_page_count?: number | null, max_page_count?: number | null, may_overlap_with_siblings?: boolean | null, order_weight?: number | null, always_include_in_blind_processing_decision: boolean, export_enabled?: boolean | null, comments?: string | null, created: Date, updated: Date, category?: string | null, exporter_settings?: object | null, exporter_settings_schema?: object | null, deleted_at?: Date | null, export_timeout?: number | null, export_parallelization?: number | null, export_queue?: string | null, prediction_queue?: string | null, search_keywords?: Array<string> | null, blind_processing_thresholds?: Array<{ __typename?: 'BlindProcessingThreshold', confirmedness: number, score: number }> | null, regex_validators: Array<{ __typename?: 'RegexValidator', pattern: string, error_message: string }> } | null, children?: { __typename?: 'DocumentClassChildrenConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: any | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: any | null }, edges: Array<{ __typename?: 'DocumentClassEdge', cursor: any, node: { __typename?: 'DocumentClass', identifier: string, local_identifier: string, display_name: string, selection_mode: SelectionMode, parent_id?: string | null, identifier_by_organization?: string | null, organization_id: string, description?: string | null, auto_predictor_mode: AutoPredictorMode, possible_value?: DataType | null, min_count?: number | null, max_count?: number | null, min_page_count?: number | null, max_page_count?: number | null, may_overlap_with_siblings?: boolean | null, order_weight?: number | null, always_include_in_blind_processing_decision: boolean, export_enabled?: boolean | null, comments?: string | null, created: Date, updated: Date, category?: string | null, exporter_settings?: object | null, exporter_settings_schema?: object | null, deleted_at?: Date | null, export_timeout?: number | null, export_parallelization?: number | null, export_queue?: string | null, prediction_queue?: string | null, search_keywords?: Array<string> | null, blind_processing_thresholds?: Array<{ __typename?: 'BlindProcessingThreshold', confirmedness: number, score: number }> | null, regex_validators: Array<{ __typename?: 'RegexValidator', pattern: string, error_message: string }> } }> } | null } }> } };

export type DocumentClassesByRegexQueryVariables = Exact<{
  filter: DocumentClassFilter;
  regex: Scalars['String'];
  paging?: InputMaybe<CursorPaging>;
  sorting?: InputMaybe<Array<DocumentClassSort> | DocumentClassSort>;
  withDetail?: InputMaybe<Scalars['Boolean']>;
  simple?: InputMaybe<Scalars['Boolean']>;
  childrenFilter?: InputMaybe<DocumentClassFilter>;
}>;


export type DocumentClassesByRegexQuery = { __typename?: 'Query', documentClassesByRegex: { __typename?: 'DocumentClassConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: any | null, endCursor?: any | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, edges: Array<{ __typename?: 'DocumentClassEdge', cursor: any, node: { __typename?: 'DocumentClass', identifier: string, local_identifier: string, display_name: string, selection_mode: SelectionMode, parent_id?: string | null, identifier_by_organization?: string | null, organization_id: string, description?: string | null, auto_predictor_mode: AutoPredictorMode, possible_value?: DataType | null, min_count?: number | null, max_count?: number | null, min_page_count?: number | null, max_page_count?: number | null, may_overlap_with_siblings?: boolean | null, order_weight?: number | null, always_include_in_blind_processing_decision: boolean, export_enabled?: boolean | null, comments?: string | null, created: Date, updated: Date, category?: string | null, exporter_settings?: object | null, exporter_settings_schema?: object | null, deleted_at?: Date | null, export_timeout?: number | null, export_parallelization?: number | null, export_queue?: string | null, prediction_queue?: string | null, search_keywords?: Array<string> | null, blind_processing_thresholds?: Array<{ __typename?: 'BlindProcessingThreshold', confirmedness: number, score: number }> | null, regex_validators: Array<{ __typename?: 'RegexValidator', pattern: string, error_message: string }>, parent?: { __typename?: 'DocumentClass', identifier: string, local_identifier: string, display_name: string, selection_mode: SelectionMode, parent_id?: string | null, identifier_by_organization?: string | null, organization_id: string, description?: string | null, auto_predictor_mode: AutoPredictorMode, possible_value?: DataType | null, min_count?: number | null, max_count?: number | null, min_page_count?: number | null, max_page_count?: number | null, may_overlap_with_siblings?: boolean | null, order_weight?: number | null, always_include_in_blind_processing_decision: boolean, export_enabled?: boolean | null, comments?: string | null, created: Date, updated: Date, category?: string | null, exporter_settings?: object | null, exporter_settings_schema?: object | null, deleted_at?: Date | null, export_timeout?: number | null, export_parallelization?: number | null, export_queue?: string | null, prediction_queue?: string | null, search_keywords?: Array<string> | null, blind_processing_thresholds?: Array<{ __typename?: 'BlindProcessingThreshold', confirmedness: number, score: number }> | null, regex_validators: Array<{ __typename?: 'RegexValidator', pattern: string, error_message: string }> } | null, children?: { __typename?: 'DocumentClassChildrenConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: any | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: any | null }, edges: Array<{ __typename?: 'DocumentClassEdge', cursor: any, node: { __typename?: 'DocumentClass', identifier: string, local_identifier: string, display_name: string, selection_mode: SelectionMode, parent_id?: string | null, identifier_by_organization?: string | null, organization_id: string, description?: string | null, auto_predictor_mode: AutoPredictorMode, possible_value?: DataType | null, min_count?: number | null, max_count?: number | null, min_page_count?: number | null, max_page_count?: number | null, may_overlap_with_siblings?: boolean | null, order_weight?: number | null, always_include_in_blind_processing_decision: boolean, export_enabled?: boolean | null, comments?: string | null, created: Date, updated: Date, category?: string | null, exporter_settings?: object | null, exporter_settings_schema?: object | null, deleted_at?: Date | null, export_timeout?: number | null, export_parallelization?: number | null, export_queue?: string | null, prediction_queue?: string | null, search_keywords?: Array<string> | null, blind_processing_thresholds?: Array<{ __typename?: 'BlindProcessingThreshold', confirmedness: number, score: number }> | null, regex_validators: Array<{ __typename?: 'RegexValidator', pattern: string, error_message: string }> } }> } | null } }> } };

export type CreateOneDocumentClassMutationVariables = Exact<{
  input: CreateOneDocumentClassInput;
}>;


export type CreateOneDocumentClassMutation = { __typename?: 'Mutation', createOneDocumentClass: { __typename?: 'DocumentClass', identifier: string, display_name: string, organization_id: string } };

export type UpdateManyDocumentClassesMutationVariables = Exact<{
  input: UpdateManyDocumentClassesInput;
}>;


export type UpdateManyDocumentClassesMutation = { __typename?: 'Mutation', updateManyDocumentClasses: { __typename?: 'UpdateManyResponse', updatedCount: number } };

export type UpdatedOneDocumentClassSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UpdatedOneDocumentClassSubscription = { __typename?: 'Subscription', updatedOneDocumentClass: { __typename?: 'DocumentClass', identifier: string, display_name: string, organization_id: string } };

export type CreatedDocumentClassSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type CreatedDocumentClassSubscription = { __typename?: 'Subscription', createdDocumentClass: { __typename?: 'DocumentClass', identifier: string, display_name: string, organization_id: string } };

export type OrganizationMembershipFragment = { __typename?: 'OrganizationMembership', organization_id: string, user_email: string, roles: Array<OrganizationRole>, organization: { __typename?: 'Organization', name: string, identifier: string }, user: { __typename?: 'User', email: string, name: string } };

export type UpdateManyOrganizationMembershipsMutationVariables = Exact<{
  input: UpdateManyOrganizationMembershipsInput;
}>;


export type UpdateManyOrganizationMembershipsMutation = { __typename?: 'Mutation', updateManyOrganizationMemberships: { __typename?: 'UpdateManyResponse', updatedCount: number } };

export type CreateManyOrganizationMembershipsMutationVariables = Exact<{
  input: CreateManyOrganizationMembershipsInput;
}>;


export type CreateManyOrganizationMembershipsMutation = { __typename?: 'Mutation', createManyOrganizationMemberships: Array<{ __typename?: 'OrganizationMembership', organization_id: string, user_email: string, roles: Array<OrganizationRole> }> };

export type DeleteManyOrganizationMembershipsMutationVariables = Exact<{
  input: DeleteManyOrganizationMembershipsInput;
}>;


export type DeleteManyOrganizationMembershipsMutation = { __typename?: 'Mutation', deleteManyOrganizationMemberships: { __typename?: 'DeleteManyResponse', deletedCount: number } };

export type OrganizationFragment = { __typename?: 'Organization', name: string, identifier: string, frontend_category_settings?: object | null, show_freshdesk_widget: boolean, created?: Date | null, updated?: Date | null, organization_memberships?: Array<{ __typename?: 'OrganizationMembership', organization_id: string, roles: Array<OrganizationRole>, user: { __typename?: 'User', email: string } }> | null };

export type OrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationsQuery = { __typename?: 'Query', organizations: Array<{ __typename?: 'Organization', name: string, identifier: string, frontend_category_settings?: object | null, show_freshdesk_widget: boolean, created?: Date | null, updated?: Date | null, organization_memberships?: Array<{ __typename?: 'OrganizationMembership', organization_id: string, roles: Array<OrganizationRole>, user: { __typename?: 'User', email: string } }> | null }> };

export type OrganizationByIdentifierQueryVariables = Exact<{
  identifier: Scalars['String'];
}>;


export type OrganizationByIdentifierQuery = { __typename?: 'Query', organizationByIdentifier: { __typename?: 'Organization', name: string, identifier: string, frontend_category_settings?: object | null, show_freshdesk_widget: boolean, created?: Date | null, updated?: Date | null, organization_memberships?: Array<{ __typename?: 'OrganizationMembership', organization_id: string, roles: Array<OrganizationRole>, user: { __typename?: 'User', email: string } }> | null } };

export type CreateOneOrganizationMutationVariables = Exact<{
  input: CreateOneOrganizationInput;
}>;


export type CreateOneOrganizationMutation = { __typename?: 'Mutation', createOneOrganization: { __typename?: 'Organization', identifier: string, name: string } };

export type UpdateManyOrganizationsMutationVariables = Exact<{
  input: UpdateManyOrganizationsInput;
}>;


export type UpdateManyOrganizationsMutation = { __typename?: 'Mutation', updateManyOrganizations: { __typename?: 'UpdateManyResponse', updatedCount: number } };

export type UpdatedOneOrganizationSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UpdatedOneOrganizationSubscription = { __typename?: 'Subscription', updatedOneOrganization: { __typename?: 'Organization', identifier: string, name: string } };

export type UserFragment = { __typename?: 'User', email: string, first_name?: string | null, last_name?: string | null, name: string, login_disabled: boolean, last_login?: Date | null, platform_roles: Array<PlatformRole>, created?: Date | null, updated?: Date | null, organization_memberships: Array<{ __typename?: 'OrganizationMembership', organization_id: string, user_email: string, roles: Array<OrganizationRole>, created: Date, organization: { __typename?: 'Organization', name: string } }> };

export type UsersQueryVariables = Exact<{
  filter?: InputMaybe<UserFilter>;
  paging?: InputMaybe<CursorPaging>;
  sorting?: InputMaybe<Array<UserSort> | UserSort>;
}>;


export type UsersQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: any | null, endCursor?: any | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', email: string, first_name?: string | null, last_name?: string | null, name: string, login_disabled: boolean, last_login?: Date | null, platform_roles: Array<PlatformRole>, created?: Date | null, updated?: Date | null, organization_memberships: Array<{ __typename?: 'OrganizationMembership', organization_id: string, user_email: string, roles: Array<OrganizationRole>, created: Date, organization: { __typename?: 'Organization', name: string } }> } }> } };

export type CreateOneUserMutationVariables = Exact<{
  input: CreateOneUserInput;
}>;


export type CreateOneUserMutation = { __typename?: 'Mutation', createOneUser: { __typename?: 'User', email: string, name: string, login_disabled: boolean } };

export type UpdateManyUsersMutationVariables = Exact<{
  input: UpdateManyUsersInput;
}>;


export type UpdateManyUsersMutation = { __typename?: 'Mutation', updateManyUsers: { __typename?: 'UpdateManyResponse', updatedCount: number } };

export type ChangePasswordMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: boolean };

export type UpdatedManyUsersSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UpdatedManyUsersSubscription = { __typename?: 'Subscription', updatedManyUsers: { __typename?: 'UpdateManyResponse', updatedCount: number } };

export type CreatedUserSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type CreatedUserSubscription = { __typename?: 'Subscription', createdUser: { __typename?: 'User', email: string, first_name?: string | null, last_name?: string | null, name: string, login_disabled: boolean, last_login?: Date | null, platform_roles: Array<PlatformRole>, created?: Date | null, updated?: Date | null, organization_memberships: Array<{ __typename?: 'OrganizationMembership', organization_id: string, user_email: string, roles: Array<OrganizationRole>, created: Date, organization: { __typename?: 'Organization', name: string } }> } };

export type UpdatedOneUserSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UpdatedOneUserSubscription = { __typename?: 'Subscription', updatedOneUser: { __typename?: 'User', email: string, first_name?: string | null, last_name?: string | null, name: string, login_disabled: boolean, last_login?: Date | null, platform_roles: Array<PlatformRole>, created?: Date | null, updated?: Date | null, organization_memberships: Array<{ __typename?: 'OrganizationMembership', organization_id: string, user_email: string, roles: Array<OrganizationRole>, created: Date, organization: { __typename?: 'Organization', name: string } }> } };

export type DeletedOneUserSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type DeletedOneUserSubscription = { __typename?: 'Subscription', deletedOneUser: { __typename?: 'UserDeleteResponse', deleted?: Date | null } };

export const SimpleDocumentClassFragmentFragmentDoc = gql`
    fragment simpleDocumentClassFragment on DocumentClass {
  identifier
  local_identifier
  display_name
}
    `;
export const DocumentClassFragmentFragmentDoc = gql`
    fragment documentClassFragment on DocumentClass {
  identifier
  local_identifier
  display_name
  selection_mode
  parent_id
  identifier_by_organization
  organization_id
  description
  auto_predictor_mode
  possible_value
  min_count
  max_count
  min_page_count
  max_page_count
  may_overlap_with_siblings
  order_weight
  blind_processing_thresholds {
    confirmedness
    score
  }
  always_include_in_blind_processing_decision
  export_enabled
  comments
  created
  updated
  category
  exporter_settings
  exporter_settings_schema
  deleted_at
  export_timeout
  export_parallelization
  export_queue
  prediction_queue
  search_keywords
  regex_validators {
    pattern
    error_message
  }
}
    `;
export const FullDocumentClassFragmentFragmentDoc = gql`
    fragment fullDocumentClassFragment on DocumentClass {
  parent {
    ...documentClassFragment
  }
  children(filter: $childrenFilter) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    edges {
      cursor
      node {
        ...documentClassFragment
      }
    }
  }
}
    ${DocumentClassFragmentFragmentDoc}`;
export const OrganizationMembershipFragmentDoc = gql`
    fragment organizationMembership on OrganizationMembership {
  organization_id
  organization {
    name
    identifier
  }
  user {
    email
    name
  }
  user_email
  roles
}
    `;
export const OrganizationFragmentDoc = gql`
    fragment organization on Organization {
  name
  organization_memberships {
    organization_id
    user {
      email
    }
    roles
  }
  identifier
  frontend_category_settings
  show_freshdesk_widget
  created
  updated
}
    `;
export const UserFragmentDoc = gql`
    fragment user on User {
  email
  first_name
  last_name
  name
  login_disabled
  last_login
  platform_roles
  organization_memberships {
    organization_id
    organization {
      name
    }
    user_email
    roles
    created
  }
  created
  updated
}
    `;
export const DocumentClassesDocument = gql`
    query documentClasses($filter: DocumentClassFilter!, $paging: CursorPaging, $sorting: [DocumentClassSort!], $withDetail: Boolean = true, $simple: Boolean = false, $childrenFilter: DocumentClassFilter) {
  documentClasses(filter: $filter, paging: $paging, sorting: $sorting) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...simpleDocumentClassFragment @include(if: $simple)
        ...documentClassFragment @skip(if: $simple)
        ...fullDocumentClassFragment @include(if: $withDetail)
      }
    }
  }
}
    ${SimpleDocumentClassFragmentFragmentDoc}
${DocumentClassFragmentFragmentDoc}
${FullDocumentClassFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentClassesGQL extends Apollo.Query<DocumentClassesQuery, DocumentClassesQueryVariables> {
    override document = DocumentClassesDocument;
    override client = 'data';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DocumentClassesByRegexDocument = gql`
    query documentClassesByRegex($filter: DocumentClassFilter!, $regex: String!, $paging: CursorPaging, $sorting: [DocumentClassSort!], $withDetail: Boolean = true, $simple: Boolean = false, $childrenFilter: DocumentClassFilter) {
  documentClassesByRegex(
    filter: $filter
    regex: $regex
    paging: $paging
    sorting: $sorting
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...simpleDocumentClassFragment @include(if: $simple)
        ...documentClassFragment @skip(if: $simple)
        ...fullDocumentClassFragment @include(if: $withDetail)
      }
    }
  }
}
    ${SimpleDocumentClassFragmentFragmentDoc}
${DocumentClassFragmentFragmentDoc}
${FullDocumentClassFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentClassesByRegexGQL extends Apollo.Query<DocumentClassesByRegexQuery, DocumentClassesByRegexQueryVariables> {
    override document = DocumentClassesByRegexDocument;
    override client = 'data';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOneDocumentClassDocument = gql`
    mutation createOneDocumentClass($input: CreateOneDocumentClassInput!) {
  createOneDocumentClass(input: $input) {
    identifier
    display_name
    organization_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOneDocumentClassGQL extends Apollo.Mutation<CreateOneDocumentClassMutation, CreateOneDocumentClassMutationVariables> {
    override document = CreateOneDocumentClassDocument;
    override client = 'data';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateManyDocumentClassesDocument = gql`
    mutation updateManyDocumentClasses($input: UpdateManyDocumentClassesInput!) {
  updateManyDocumentClasses(input: $input) {
    updatedCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateManyDocumentClassesGQL extends Apollo.Mutation<UpdateManyDocumentClassesMutation, UpdateManyDocumentClassesMutationVariables> {
    override document = UpdateManyDocumentClassesDocument;
    override client = 'data';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatedOneDocumentClassDocument = gql`
    subscription updatedOneDocumentClass {
  updatedOneDocumentClass {
    identifier
    display_name
    organization_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatedOneDocumentClassGQL extends Apollo.Subscription<UpdatedOneDocumentClassSubscription, UpdatedOneDocumentClassSubscriptionVariables> {
    override document = UpdatedOneDocumentClassDocument;
    override client = 'data';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatedDocumentClassDocument = gql`
    subscription createdDocumentClass {
  createdDocumentClass {
    identifier
    display_name
    organization_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatedDocumentClassGQL extends Apollo.Subscription<CreatedDocumentClassSubscription, CreatedDocumentClassSubscriptionVariables> {
    override document = CreatedDocumentClassDocument;
    override client = 'data';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateManyOrganizationMembershipsDocument = gql`
    mutation updateManyOrganizationMemberships($input: UpdateManyOrganizationMembershipsInput!) {
  updateManyOrganizationMemberships(input: $input) {
    updatedCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateManyOrganizationMembershipsGQL extends Apollo.Mutation<UpdateManyOrganizationMembershipsMutation, UpdateManyOrganizationMembershipsMutationVariables> {
    override document = UpdateManyOrganizationMembershipsDocument;
    override client = 'data';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateManyOrganizationMembershipsDocument = gql`
    mutation createManyOrganizationMemberships($input: CreateManyOrganizationMembershipsInput!) {
  createManyOrganizationMemberships(input: $input) {
    organization_id
    user_email
    roles
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateManyOrganizationMembershipsGQL extends Apollo.Mutation<CreateManyOrganizationMembershipsMutation, CreateManyOrganizationMembershipsMutationVariables> {
    override document = CreateManyOrganizationMembershipsDocument;
    override client = 'data';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteManyOrganizationMembershipsDocument = gql`
    mutation deleteManyOrganizationMemberships($input: DeleteManyOrganizationMembershipsInput!) {
  deleteManyOrganizationMemberships(input: $input) {
    deletedCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteManyOrganizationMembershipsGQL extends Apollo.Mutation<DeleteManyOrganizationMembershipsMutation, DeleteManyOrganizationMembershipsMutationVariables> {
    override document = DeleteManyOrganizationMembershipsDocument;
    override client = 'data';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrganizationsDocument = gql`
    query organizations {
  organizations {
    ...organization
  }
}
    ${OrganizationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizationsGQL extends Apollo.Query<OrganizationsQuery, OrganizationsQueryVariables> {
    override document = OrganizationsDocument;
    override client = 'data';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrganizationByIdentifierDocument = gql`
    query organizationByIdentifier($identifier: String!) {
  organizationByIdentifier(identifier: $identifier) {
    ...organization
  }
}
    ${OrganizationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizationByIdentifierGQL extends Apollo.Query<OrganizationByIdentifierQuery, OrganizationByIdentifierQueryVariables> {
    override document = OrganizationByIdentifierDocument;
    override client = 'data';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOneOrganizationDocument = gql`
    mutation createOneOrganization($input: CreateOneOrganizationInput!) {
  createOneOrganization(input: $input) {
    identifier
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOneOrganizationGQL extends Apollo.Mutation<CreateOneOrganizationMutation, CreateOneOrganizationMutationVariables> {
    override document = CreateOneOrganizationDocument;
    override client = 'data';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateManyOrganizationsDocument = gql`
    mutation updateManyOrganizations($input: UpdateManyOrganizationsInput!) {
  updateManyOrganizations(input: $input) {
    updatedCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateManyOrganizationsGQL extends Apollo.Mutation<UpdateManyOrganizationsMutation, UpdateManyOrganizationsMutationVariables> {
    override document = UpdateManyOrganizationsDocument;
    override client = 'data';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatedOneOrganizationDocument = gql`
    subscription updatedOneOrganization {
  updatedOneOrganization {
    identifier
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatedOneOrganizationGQL extends Apollo.Subscription<UpdatedOneOrganizationSubscription, UpdatedOneOrganizationSubscriptionVariables> {
    override document = UpdatedOneOrganizationDocument;
    override client = 'data';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UsersDocument = gql`
    query users($filter: UserFilter, $paging: CursorPaging, $sorting: [UserSort!]) {
  users(filter: $filter, paging: $paging, sorting: $sorting) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        ...user
      }
    }
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UsersGQL extends Apollo.Query<UsersQuery, UsersQueryVariables> {
    override document = UsersDocument;
    override client = 'data';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOneUserDocument = gql`
    mutation createOneUser($input: CreateOneUserInput!) {
  createOneUser(input: $input) {
    email
    name
    login_disabled
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOneUserGQL extends Apollo.Mutation<CreateOneUserMutation, CreateOneUserMutationVariables> {
    override document = CreateOneUserDocument;
    override client = 'data';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateManyUsersDocument = gql`
    mutation updateManyUsers($input: UpdateManyUsersInput!) {
  updateManyUsers(input: $input) {
    updatedCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateManyUsersGQL extends Apollo.Mutation<UpdateManyUsersMutation, UpdateManyUsersMutationVariables> {
    override document = UpdateManyUsersDocument;
    override client = 'data';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangePasswordDocument = gql`
    mutation changePassword($email: String!, $password: String!) {
  changePassword(email: $email, password: $password)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangePasswordGQL extends Apollo.Mutation<ChangePasswordMutation, ChangePasswordMutationVariables> {
    override document = ChangePasswordDocument;
    override client = 'data';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatedManyUsersDocument = gql`
    subscription updatedManyUsers {
  updatedManyUsers {
    updatedCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatedManyUsersGQL extends Apollo.Subscription<UpdatedManyUsersSubscription, UpdatedManyUsersSubscriptionVariables> {
    override document = UpdatedManyUsersDocument;
    override client = 'data';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatedUserDocument = gql`
    subscription createdUser {
  createdUser {
    ...user
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatedUserGQL extends Apollo.Subscription<CreatedUserSubscription, CreatedUserSubscriptionVariables> {
    override document = CreatedUserDocument;
    override client = 'data';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatedOneUserDocument = gql`
    subscription updatedOneUser {
  updatedOneUser {
    ...user
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatedOneUserGQL extends Apollo.Subscription<UpdatedOneUserSubscription, UpdatedOneUserSubscriptionVariables> {
    override document = UpdatedOneUserDocument;
    override client = 'data';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletedOneUserDocument = gql`
    subscription deletedOneUser {
  deletedOneUser {
    deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletedOneUserGQL extends Apollo.Subscription<DeletedOneUserSubscription, DeletedOneUserSubscriptionVariables> {
    override document = DeletedOneUserDocument;
    override client = 'data';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }